export const uiErrorSelector = state => state.ui.error;

export const pathnameSelector = state => state.ui.router.location.pathname;



// WEBPACK FOOTER //
// ./src/sc/selectors/ui.js